import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { monitorApi } from '../services/api';
import { APP_CONFIG } from '../config/appConfig';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const detectedTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
      const res = await monitorApi.login(username, password, detectedTimezone);
      const store = window.localStorage;
      store.setItem('auth_token', res.data.token);
      store.setItem('auth_user', res.data.username);
      store.setItem('auth_timezone', res.data.timezone || detectedTimezone);
      store.setItem('auth_last_activity_at', String(Date.now()));
      navigate('/admin/monitors');
    } catch (err: any) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100 px-4">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-6">
          <img src="/emerson-logo.png" alt="Emerson" className="w-12 h-12 rounded-xl object-contain mb-3" />
          <h1 className="text-xl font-bold text-slate-800">{APP_CONFIG.TITLE}</h1>
          <p className="text-sm text-slate-500">Admin sign in</p>
        </div>

        <form onSubmit={submit} className="bg-white rounded-xl border border-slate-200 p-6 space-y-4">
          {error && (
            <div className="bg-red-50 text-red-700 text-sm rounded-md px-3 py-2 border border-red-100">{error}</div>
          )}
          <div>
            <label className="block text-sm font-medium text-slate-600 mb-1">Username</label>
            <input
              type="text"
              value={username}
              onChange={e => setUsername(e.target.value)}
              autoFocus
              required
              className="w-full border border-slate-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-brand/40"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-600 mb-1">Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              className="w-full border border-slate-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-brand/40"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full flex items-center justify-center gap-2 bg-brand text-white font-medium py-2 rounded-md hover:bg-brand-dark disabled:opacity-60"
          >
            <Lock size={16} /> {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
